import { render, staticRenderFns } from "./PromoItem.vue?vue&type=template&id=4d1ee925&scoped=true&"
import script from "./PromoItem.vue?vue&type=script&lang=js&"
export * from "./PromoItem.vue?vue&type=script&lang=js&"
import style0 from "./PromoItem.vue?vue&type=style&index=0&id=4d1ee925&lang=scss&scoped=true&"
import style1 from "./PromoItem.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1ee925",
  null
  
)

export default component.exports